export const isContentEmpty = (content = {}) => {
  const { title, body, topic, bottomLink } = content;
  if (title) return false;
  if (body && body.length > 0) return false;
  if (topic && topic.text) return false;
  if (bottomLink && bottomLink.href) return false;

  return true;
};
